export const AaaGameInformationFormId = "aaa-game-information";

export enum AaaGameInformationSubFormsId {
  ConceptDetails = "details",
  DistributionInformation = "distributionInformation",
  GameExpectations = "gameExpectations",
  Availability = "availability",
  TechnicalCapabilities = "technicalCapabilities",
  Configurations = "configurations",
  XboxNetwork = "xboxNetwork",
  Ugc = "ugc",
  SupplementaryData = "supplementaryData",
}

export const AaaGameInformationSubFormsIdsOrder = [
  AaaGameInformationSubFormsId.ConceptDetails,
  AaaGameInformationSubFormsId.DistributionInformation,
  AaaGameInformationSubFormsId.GameExpectations,
  AaaGameInformationSubFormsId.Availability,
  AaaGameInformationSubFormsId.TechnicalCapabilities,
  AaaGameInformationSubFormsId.Configurations,
  AaaGameInformationSubFormsId.XboxNetwork,
  AaaGameInformationSubFormsId.Ugc,
  AaaGameInformationSubFormsId.SupplementaryData,
];

export const AaaGameInformationSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "gameInformationTitle",
  ["formSubtitle"]: "gameInformationSubtitleDescription",
  [AaaGameInformationSubFormsId.ConceptDetails]: "gameInformationConceptDetailsTitle",
  [AaaGameInformationSubFormsId.DistributionInformation]:
    "gameInformationDistributionInformationTitle",
  [AaaGameInformationSubFormsId.GameExpectations]: "gameInformationGameExpectationsTitle",
  [AaaGameInformationSubFormsId.Availability]: "gameInformationAvailabilityTitle",
  [AaaGameInformationSubFormsId.TechnicalCapabilities]: "gameInformationTechnicalCapabilitiesTitle",
  [AaaGameInformationSubFormsId.Configurations]: "gameInformationConfigurationsTitle",
  [AaaGameInformationSubFormsId.XboxNetwork]: "gameInformationXboxNetworkTitle",
  [AaaGameInformationSubFormsId.Ugc]: "gameInformationUgcTitle",
  [AaaGameInformationSubFormsId.SupplementaryData]: "gameInformationSupplementaryDataTitle",
};
